<template>
    <div class="">
        <div class="row">
            <div class="col s12" style="display:flex;align-items: center;">
                <div ref="menusearch" class="input-field inline">
                    <i class="material-icons prefix">search</i>
                    <input id="email_inline" type="email" class="validate"
                        @input="search = $event.target.value">
                    <label for="email_inline">Search</label>
                </div>
                <a class="btn" style="width:50px;margin-left:5px;z-index:1000;" @click="$emit('newfile')" v-if="edit">
                    <i class="material-icons">add</i>
                    <span style="transform:translate(0px, -4px);padding-left:5px;display:inline-block;">New Post</span>
                </a>
            </div>
        </div>
        <div style="height:70vh;overflow-y:scroll;" ref="notesmenu" v-html="notehtml"></div>
    </div> 
</template>

<script>

export default {
    name: '',
    props: {
        notelist: {
            type: Array,
            default: () => []
        },
        edit: {
            type: Boolean,
            default: false,
        },
    },
    data(){
        return {
            search: '',
        }
    },
    beforeMount(){
        // this.toEdit = to.edit
    },
    components: {

    },
    computed: {
        notehtml(){
            if (!this.notelist) return
            let s = this.search.toLowerCase()
            let notelist = []
            console.log(this.notelist)
            if (s == '')
                notelist = [...this.notelist]
            else
                notelist = this.notelist.filter(d => d.title.includes(s))
            console.log('notelist', notelist)
            const notestruct = notelist.sort((a,b) => {return a.title - b.title})
                .reduce((g,c,i) => {
                console.log(c)
                let c2 = c.title.split('/')
                let gtemp = g
                for (let idx in c2){
                    let c3 = c2[idx]
                    let found = false
                    for (let node of gtemp.children){
                        if (node.name == c3){
                            found = true
                            gtemp = node
                            break
                        }
                    }
                    if (!found){
                        let link = {}
                        if (idx == c2.length-1)
                            link = {link: c}
                        let aux = {
                            name: c3,
                            label: c2[idx],
                            children: [],
                            ...link,
                            key: c.key
                        }
                        gtemp.children.push(aux)
                        gtemp = aux
                    }
                }
                return g
            }, {name: '___root', children: []})
            console.log('notesstruct', notestruct)
            let html = '<ul>'
            const looper = (node, path='') => {
                if (node.name == '___root'){
                    for (let c of node.children){
                        html += '<ul>'
                        looper(c, path)
                        html += '</ul>'
                    }
                }else{
                    html += `<li onmousemove="event.stopPropagation(); event.target.querySelector('img') ? event.target.querySelector('img').style.opacity=100 : ''" 
                                onmouseout="event.stopPropagation(); event.target.querySelector('img') ? event.target.querySelector('img').style.opacity=0 : ''"/>`
                    if (node.link)
                        // html += `<a href="#!" onclick="window.fileClick('${btoa(JSON.stringify(node))}')">${node.label}</a>`
                        html += `<a href="#!" onclick="window.fileClick('${node.link.title}')">${node.label}</a>`
                    else
                        html += node.label
                    let path2 = path + '/' + node.label
                    if (this.edit){
                        let toadd = `${path2.slice(1,path2.length)}/`
                        console.log('toadd', node)
                        if (node.children && node.children.length > 0){
                            let m = node.children[0].name.match(/(\d+)\. \d+\w+\d{2}/)
                            console.log('m', m)
                            let mon = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul',
                                            'ago', 'sep', 'oct', 'nov', 'dec']
                            if (m){
                                let ndate = new Date()
                                let [fullmatch, idx] = m
                                toadd += `${+idx-1}. ${ndate.getDate()}${mon[ndate.getMonth()]}${ndate.getFullYear()-2000} `
                            }
                        }
                        html += ` <img 
                                    onmousemove="event.stopPropagation(); event.target.style.opacity=100" 
                                    onmouseout="event.stopPropagation(); event.target.style.opacity=0"
                        class="imghover" style="cursor:pointer;opacity:0;width:14px;" 
                        src="/assets/icons/plus.png" onclick="window.newFile('${toadd}')"/>`
                    }
                    for (let c of node.children){
                        html += '<ul>'
                        looper(c, path+'/'+node.label)
                        html += '</ul>'
                    }
                    html += '</li>'
                }
            }
            looper(notestruct)
            html += '</ul>'
            return html
        }

    },
    mounted(){
        const obj = this
        const menu = this.$refs.notesmenu
        let bbmenu = menu.getBoundingClientRect()
        menu.style.width = `${bbmenu.width}px`
        const menusearch = this.$refs.menusearch
        // console.log('menu', menu)
        window.addEventListener('scroll', (e) => {
          // console.log('obj', obj.$refs.cm)
          // console.log(mk.getBoundingClientRect())
          // console.log(obj.$refs)
          let bb = menusearch.getBoundingClientRect()
          // console.log('sb', sb)
          // console.log('---', bb.top, mk.getBoundingClientRect().top)
        //   if (!window.bbmenu){
        //     window.bbmenu = bbmenu
        //   }
          if (bb.top < 10) {
            menu.style.position = 'fixed'
            menu.style.top = '10px'
            menu.style.height = '90vh'
          }else{
            menu.style.position = 'inherit'
            menu.style.height = '70vh'
            menu.style.top = null
            // menu.style.width = `${bb.width}px`
          }
        })
    },
    methods: {

    },
}
</script>

<style>
</style>